// 화면과 서버가 같이 쓰는 아이디 (docs/architecture.md 1장, v2 architecture-review 4.2). 이 폴더는 아무것도 가져오지 않는다

// 장소 아이디: 마을과 건물 안 셋. (모험 스테이지는 아래 PlaceId의 `stage:…`)
// 장소의 픽셀 크기는 shared/world/rooms.ts. (웹소켓 ?room= 은 초대 링크 방 하나이고, 이 장소와는 다르다: 초대 방 안에 장소가 넷 있다)
export const ROOM_IDS = ['town', 'school', 'office', 'starbox'] as const;
export type RoomId = (typeof ROOM_IDS)[number];
export const isRoomId = (v: unknown): v is RoomId => typeof v === 'string' && (ROOM_IDS as readonly string[]).includes(v);

// 학교는 교실이다: 발언권·송출 규칙(server/2-controllers/meeting/classroom.ts)이 이 장소에서만 선다
export const CLASSROOM: RoomId = 'school';
export const inClassroom = (o: { room: RoomId | null }) => o.room === CLASSROOM;

// 모험 스테이지 아이디: 클라이언트 게임 데이터(client/4-catalog/game/data.js의 G.NODES)와 같은 목록이다. tools/check-world.mjs가 둘이 어긋나면 실패시킨다.
// 스테이지 안에서도 같은 스테이지에 들어온 사람끼리는 서로 보이고 음성이 이어진다(적·아이템·죽음은 각자). 그래서 스테이지는 장소(PlaceId)의 한 종류다: `stage:<스테이지 아이디>`.
export const STAGE_IDS = ['1-1', '1-2', '1-3', '1-B', '2-1', '2-2', '2-3', '2-B', '3-1', '3-2', '3-3', '3-B', '4-1', '4-2', '4-3', '4-B', '5-1', '5-B'] as const;
export type StageId = (typeof STAGE_IDS)[number];
export type StagePlace = `stage:${StageId}`;
export type PlaceId = RoomId | StagePlace;
export const stagePlace = (id: StageId): StagePlace => `stage:${id}`;
export const isStagePlace = (v: unknown): v is StagePlace => typeof v === 'string' && v.startsWith('stage:') && (STAGE_IDS as readonly string[]).includes(v.slice(6));
export const stageOf = (p: PlaceId | null): StageId | null => (isStagePlace(p) ? (p.slice(6) as StageId) : null);
export const isPlaceId = (v: unknown): v is PlaceId => isRoomId(v) || isStagePlace(v);

// 걷는 모습 (pos의 st). 앉은 모습은 pos가 아니라 meet의 seat이 알린다. st 'sit'는 앉은 사람이 보내는 값이다
export const ANIMS = ['idle', 'walk', 'jump', 'dash', 'sit'] as const;
export type Anim = (typeof ANIMS)[number];
export const isAnim = (v: unknown): v is Anim => typeof v === 'string' && (ANIMS as readonly string[]).includes(v);
